import { i18n } from '@/plugins/i18n'

export const userAccessType = {
    ALL:            null,
    BASIC_USER:     1,
    ADMIN:          2,
    WALLET_ACCESS:  3,
};

export const userAccessTypeStr = {
    ALL:            i18n.t('user_access_type.all'),
    BASIC_USER:     i18n.t('user_access_type.basic_user'),
    ADMIN:          i18n.t('user_access_type.admin'),
    WALLET_ACCESS:  i18n.t('user_access_type.wallet_access'),

    get(access_type) {
        let str = null;

        Object.keys(userAccessType).forEach(item => {
            if(userAccessType[item] === access_type) {
                str = userAccessTypeStr[item];
            }
        });

        return str;
    }
};
